import { useMutation, useQueryClient } from "@tanstack/react-query";
import { markAllNotificationsAsRead } from "../../apis";
import { useAuth } from "../auth";
import { updateNotificationsCacheAfterMarkAllRead } from "./updateNotificationsCacheAfterMarkAllRead";

export function useMarkAllNotificationsAsRead() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { mutate, error, status, data } = useMutation({
    mutationFn: () => {
      const token = user?.accessToken || "";
      return markAllNotificationsAsRead(token);
    },
    onMutate: () => {
      updateNotificationsCacheAfterMarkAllRead(queryClient, user?.id);
    },
    onSuccess: () => {
      updateNotificationsCacheAfterMarkAllRead(queryClient, user?.id);
      queryClient.invalidateQueries({
        queryKey: ["notifications"],
        exact: false,
      });
    },
    onError: () => {
      queryClient.invalidateQueries({
        queryKey: ["notifications"],
        exact: false,
      });
    },
  });

  return {
    markAllAsRead: mutate,
    error,
    status,
    data,
    isPending: status === "pending",
  };
}
